import { Pipe, PipeTransform } from '@angular/core';
import { CodeLookupPipeDelegate } from '@scisys-uim/uim-common';
import { RefCodeStorage } from 'assets-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Pipe({ name: 'refCodeDecode' })
export class RefCodeLookup implements PipeTransform, CodeLookupPipeDelegate {

  constructor(private storage: RefCodeStorage) {
    storage.resolve();
  }

  transform(value: string, domain: string): Observable<string> {
    const changedSubject = new BehaviorSubject<string>(value);
    this.storage.decode(domain, value, true).subscribe(decode => {
      if (decode == null) {
        decode = "";
      }
      changedSubject.next(decode);
    });
    return changedSubject.asObservable();
  }
}
